import { Checkbox } from '@/components/ui/checkbox';
import { PublishedCircuit } from '@/types/distributors/CircuitSelectionColumnDef';
import { Row } from '@tanstack/react-table';

const CircuitRowCheckbox = ({ row }: { row: Row<PublishedCircuit> }) => {
  const agenciesCount = row.original.agenciesCount;
  const shared = row.original._count.sharedCircuits;
  const isPartialShare =
    agenciesCount !== undefined && shared > 0 && shared < agenciesCount;

  const checked: boolean | 'indeterminate' = row.getIsSelected()
    ? true
    : isPartialShare
      ? 'indeterminate'
      : false;

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={(value) => {
        if (value === 'indeterminate') return;
        row.toggleSelected(value === true);
      }}
      aria-label="Select row"
    />
  );
};

export default CircuitRowCheckbox;
